export default __webpack_public_path__ + "static/media/s2.5a786d18.png";